import bundle from '../../generated/wiki-data.json';

export function getLocaleBundle(language) {
  const lang = language === 'zh' ? 'zh' : 'en';
  return bundle[lang] ?? bundle.en;
}

export function formatUpdated(dateStr, language = 'en') {
  if (!dateStr) return language === 'zh' ? '未知' : 'Unknown';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  const locale = language === 'zh' ? 'zh-CN' : 'en-US';
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function getWikiSections(language) {
  return getLocaleBundle(language).sections;
}

export function getSearchablePages(language) {
  return getLocaleBundle(language).searchPages;
}

export function getPageBySlugParts(slugParts, language) {
  const slug = slugParts.length ? slugParts.join('/') : 'index';
  return getLocaleBundle(language).pagesBySlug[slug] ?? null;
}

export function getIndexPage(language) {
  return getLocaleBundle(language).pagesBySlug.index ?? null;
}
